import { useQuery } from '@tanstack/react-query';
import { fetchHolidaysOptions } from '../../api/generated/@tanstack/react-query.gen';

// Re-export generated type for backwards compatibility
export type { Holiday } from '../../api/generated/types.gen';

export function useHolidaysQuery() {
  const query = useQuery(fetchHolidaysOptions());
  // Return holidays array for backwards compatibility
  return {
    ...query,
    data: query.data?.holidays,
  };
}
